export default "<router-outlet><app-spinner></app-spinner></router-outlet>\n"